import React, { useState } from 'react';
import {
    Button,
    Container,
    createStyles,
    FormControl,
    Grid,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Theme,
    Typography
} from "@material-ui/core";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { useHistory } from "react-router-dom";
import { ICliente } from '../../entities/catalogos/ICliente';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { ArrowRightAlt, Search } from '@material-ui/icons';
import useCommonApi from '../../api/useCommonApi';
import { format } from "date-fns";
import { IUsuario } from '../../entities/catalogos/IUsuario';
import LoadingDialog from '../controls/LoadingDialog';
import { Autocomplete } from '@material-ui/lab';
import swal from 'sweetalert2';
import { initialSolicitud } from "../../redux/reducers/solicitudReducer";
import { Solicitud } from '../../entities/solicitudes/Solicitud';
import { initialRecoleccionState } from '../../redux/reducers/recoleccionReducer';
import { initialMercancia } from '../../redux/reducers/mercanciaReducer';
import { Recoleccion } from '../../entities/catalogos/Recoleccion';
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { saveMercancias } from '../../redux/actions/mercanciaActions';
import { setRecoleccionDestino, setRecoleccionOrigen } from '../../redux/actions/recoleccionActions';
import { setUsuario } from '../../redux/actions/usuarioActions';
import { Mercancia } from '../../entities/solicitudes/Mercancia';
import { enums } from '../../enums/enums';
import { useSnackbar } from 'notistack';
import Help, { IHelp } from '../help/Help';
import ReferenciaNumberField from '../controls/ReferenciaNumberField';
import { MercanciaDatosComplementarios } from '../../entities/solicitudes/MercanciaDatosComplementarios';
import { saveMercanciasDatosComplementarios } from '../../redux/actions/mercanciaDatosComplementariosActions';
import { completarValoresRecoleccion, obtenerMercancias } from "../../blocks/utility";
import useGetInformacionOrigenDestino from "../../hooks/useGetInformacionOrigenDestino";
import { ILimiteServicioDiarioResponse } from '../../interfaces/ILimiteServicioDiarioResponse';
import { AreaServicio } from "../../entities/catalogos/AreaServicio";
import { updateServicios } from "../../redux/actions/servicioAdicionalActions";
import { saveTiposEnvio } from "../../redux/actions/tipoEnvioActions";
import { IServicioAdicional, ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import moment from 'moment';
import "./datepickerStyle.css";
import  DatePicker  from 'rsuite/DatePicker';
import CustomProvider from "rsuite/CustomProvider";
import es_ES from 'rsuite/locales/es_ES';
import en_US from 'rsuite/locales/en_US';
import { IResultApi } from '../../interfaces/IResultApi';
import { saveCliente } from '../../redux/actions/clienteActions';
import { Sucursal } from '../../entities/catalogos/Sucursal';
import { useAreasServiciosAll } from '../../contextos/areasServiciosAllContext';
import { RecintoAduanal } from '../../entities/catalogos/RecintoAduanal';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        container: {
            width: "100%"
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            margin: "0px",
            padding: "0 0 20px 0",
            width: "100%"
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            paddingTop: "50px",

        },
        tr: {
            fontWeight: 600,
            textAlign: "center"
        },
        trLeft: {
            fontWeight: 600,
            textAlign: "left"
        },
        filters: {
            backgroundColor: "#ececec",
            boxShadow: "none",
            verticalAlign: "middle",
            paddingTop: "10px",
        },
        label: {
            fontSize: '12px',
            fontWeight: 600,
            marginTop: "10px",
        },
        textField: {
            backgroundColor: "#fff",
            width: "180px",
            fontSize: "12px"
        },
        dateField: {
            backgroundColor: "#fff",
            width: "180px",
            fontSize: "12px"
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",

        },
        marginButton: {
            margin: "10px 0px 0 30px"
        },
        selectFilter: {
            backgroundColor: "#fff",
            width: "180px",
        },
        cellContent: {
            minWidth: "150px",
            fontSize: "12px"
        },
        buttonCell: {
            fontSize: "10px",
            width: "100px"
        },
        sectionTitle: {
            width: "100%",
            textAlign: "center",
            fontSize: "25px",
            fontWeight: 600,
            paddingLeft: "200px"
        }

    }),
);

interface StateProps {
    cliente: ICliente
    usuario: IUsuario
    ayuda: IHelp,
    sucursales: Sucursal[],
    sucursalesMany: Sucursal[]
}

interface DispatchProps {
    saveCliente: typeof saveCliente
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveMercancias: typeof saveMercancias
    saveMercanciasDatosComplementarios: typeof saveMercanciasDatosComplementarios
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    setUsuario: typeof setUsuario
    updateServicios: typeof updateServicios
    saveTiposEnvio: typeof saveTiposEnvio
}

interface IResultAuthApi extends IResultApi {
    response: { token: string, refreshToken: string }
}

interface IDatosLogin {
    resultAuthApi: IResultAuthApi
    cliente: ICliente
    etiquetas: any,
    idioma: string,
    diasRAD: string,
    tieneConveniosHD: boolean
}

type Props = StateProps & DispatchProps & IDatosLogin;

const SolicitudLista = (props: Props) => {
    

    const classes = useStyles();
    const ocultarPortal = localStorage.getItem("ocultarPortal") === "true" || localStorage.getItem("ocultarPortal") === "1";
    const history = useHistory();
    const [solicitudes, setSolicitudes] = useState<any[]>([]);
    const [showLoading, setLoading] = useState(false);
    const apiSource = useCommonApi();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [solicitudId, setSolicitudId] = useState('');
    const defaultStartDate = new Date();
    defaultStartDate.setDate(defaultStartDate.getDate()-90);
    const defaultEndDate = new Date();
    const [fechaInicio, setFechaInicio] = useState(defaultStartDate);
    const [fechaFin, setFechaFin] = useState(defaultEndDate);
    const today = new Date();
    const [referencia, setReferencia] = useState('');
    const [estatus, setEstatus] = useState<any[]>([]);
    const [estatusId, setEstatusId] = useState(-1);
    const [origen, setOrigen] = useState(0);
    const [destino, setDestino] = useState(0);
    const [oficinaOrigen, setOficinaOrigen] = useState(0);
    const [oficinaDestino, setOficinaDestino] = useState(0);
    const {areasServicios, setAreasServicios} = useAreasServiciosAll();
    //const [sucursales, setSucursales] = useState<any[]>([]);
    const { enqueueSnackbar } = useSnackbar();
    const { obtenerCoordenadas, getTipoServicio, saveServicioAdicionales } = useGetInformacionOrigenDestino(props.cliente,
        props.updateServicios, props.saveTiposEnvio);

    React.useEffect(() => {
        buscarEstatus();
        buscarSolicitudes(defaultStartDate, defaultEndDate);
        if(areasServicios.areasServicios.length === 0 || areasServicios.empresaId !== props.cliente.empresaID) {
            getAreasServicios().then(response => {
                setAreasServicios({empresaId: props.cliente.empresaID, areasServicios: response});
            });
        }
    }, []);

    const buscarEstatus = () => {

        setEstatus([{ id: 1, nombre: traducirLabel(228) }, // PENDIENTE DE RECOLECTAR
        { id: 2, nombre: traducirLabel(227) }, // PENDIENTE DE DOCUMENTAR
        { id: 3, nombre: traducirLabel(101) }, // DOCUMENTADA
        { id: 4, nombre: traducirLabel(26) }]); // CANCELADA
    }

    const buscarSolicitudes = (fechaFiltroInicio?: any, fechaFiltroFin?: any, reset?: boolean) => {
        const lastDayFormatted = format(today, "yyyy-MM-dd");
        const firstDay = new Date().setDate(today.getDate() - 90);
        const firstDayFormatted = format(firstDay, "yyyy-MM-dd");

        if (!fechaFiltroInicio) {
            fechaFiltroInicio = !fechaInicio ? firstDayFormatted : fechaInicio;
        }
        if (!fechaFiltroFin) {
            fechaFiltroFin = !fechaFin ? lastDayFormatted : fechaFin;
        }
        if (fechaFiltroInicio > fechaFiltroFin) {
            let mensaje = traducirMessage(228); // 'Rango de fechas no válidas.';
            enqueueSnackbar(mensaje, { variant: "error" });
            return;
        }
        if (new Date(fechaFiltroInicio).getFullYear() < 2000) {
            let mensaje = traducirMessage(271); // 'Fecha Inicio no válida.';
            enqueueSnackbar(mensaje, { variant: "error" });
            return;
        }
        if (new Date(fechaFiltroFin).getFullYear() < 2000) {
            let mensaje = traducirMessage(270); // 'Fecha Fin no válida.';
            enqueueSnackbar(mensaje, { variant: "error" });
            return;
        }
        setLoading(true);
        getSolicitudes(fechaFiltroInicio, fechaFiltroFin, reset).then(data => {
            let solicitudesLista: any[] = [];
            if (data !== null && data.length) {

                if (data.length === 1) {
                    var estatus = data[0]['estatusSolicitudID'];
                    if (estatus === 4) {
                        swal.fire({
                            titleText: traducirMessage(11), //'¡Aviso!',
                            text: traducirMessage(152), //"La solicitud de servicio no cuenta con las tárifas vigentes.",
                            type: 'warning',
                        });
                    }
                }

                data.forEach(s => {
                    let cont = {

                        id: s.numGuia,
                        solicitudId: s.solicitudServicioID,
                        fecha: formatDate(s.fechaAlta),
                        mercancia: s.solicitudServicioMercancias,
                        estatusId: s.estatusID,
                        estatus: s.estatusNombre,
                        origen: s.sucursalRemitente,
                        destino: s.sucursalDestinatario,
                        ocurreOrigen: s.esOcurreOrigen,
                        ocurreDestino: s.esOcurreDestino,
                        sucursalRemitente: s.sucursalRemitente,
                        sucursalDestinatario: s.sucursalDestinatario,
                        total: s.total,
                        moneda: s.monedaNombre,
                        direccionRemitente: s.direccionRemitente,
                        direccionDestinatario: s.direccionDestinatario,
                        areaServicioRemitente: s.areaServicioRemitente,
                        areaServicioDestinatario: s.areaServicioDestinatario,

                    };
                    solicitudesLista.push(cont);
                });
                setSolicitudes(solicitudesLista);
                setLoading(false);
                setPage(0);
            }
            else {
                setSolicitudes([]);
                setLoading(false);
            }
        }).catch(error => {
            setSolicitudes([]);
            setLoading(false);

        });
    }

    const getAreasServicios = async () => {
        const result = await apiSource.obtenerAsync<any>("area-servicio/by-all/" + props.cliente.empresaID);
        return result;
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getSolicitudes = async (fechaInicioInit?: any, fechaFinInit?: any, reset?: boolean) => {
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/filtered/", {
            usuarioId: props.usuario.id,
            clienteId: props.cliente.id,
            solicitudId: (reset) ? '' : solicitudId,
            estatusId: (reset) ? '1' : estatusId,
            referencia: (reset) ? '' : referencia,
            fechaInicio: fechaInicioInit ? fechaInicioInit : fechaInicio,
            fechaFin: fechaFinInit ? fechaFinInit : fechaFin,
            origen: (reset) ? 0 : origen,
            destino: (reset) ? 0 : destino,
            oficinaOrigen: (reset) ? 0 : oficinaOrigen,
            oficinaDestino: (reset) ? 0 : oficinaDestino
        });
        return result;
    };

    const formatDate = (date) => {

        const dateFormatted = new Date(date);
        var idioma = localStorage.getItem("idioma");
        if(idioma === 'en-US'){
            return dateFormatted.toLocaleString(idioma, { year: "numeric", month: "long", day: "numeric" });
        }
        else{
            return dateFormatted.toLocaleString("es", { year: "numeric", month: "long", day: "numeric" });
        }
    }

    // El endpoint regresa true cuando el cliente ya alcanzó el límite de servicios del día.
    const limiteServicioDiarioAlcanzado = async () => {
        const resLimite = await apiSource.postAsync<ILimiteServicioDiarioResponse>("solicitud-servicio/validar-limite-servicio-diario/" + props.cliente.id);

        if (resLimite && resLimite.permitirSolicitud === false) {
            setLoading(false);
            const limite = resLimite.limiteServiciosDiarios ?? (resLimite as any).limiteServicioDiario ?? 0;
            const msg = traducirMessage(370);
            const textMessage = msg.replace('{0}', limite.toString());
            swal.fire({
                titleText: traducirMessage(11), //'¡Aviso!',
                text: textMessage,
                type: 'warning',
            });
            history.push("/");
            return true;
        }

        return false;
    }

    const handleClick = async () => {


        setLoading(true);

        if (await limiteServicioDiarioAlcanzado()) {
            return;
        }

        actualizaLoginData(Number(props.cliente.id), Number(props.usuario.id), localStorage.getItem("usuario_nombre")).then(result => {

            let documentoId = 0;
            if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                result.cliente.habilitarDatosComplementarios = false;
                if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                    result.cliente.habilitarDatosComplementarios = true;
                }
                if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                    result.cliente.habilitarDatosComplementariosCartaPorte = true;
                }
                if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                    result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                }
                if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                    result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                }
                if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                    result.cliente.habilitarValidacionCoberturaEAD = true;
                }
                if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                    result.cliente.habilitarValidacionCoberturaRAD = true;
                }
                //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                //result.cliente.clienteConfiguracionMarkupDetalle = 0;

                if (result.cliente?.documentos !== null) {
                    result.cliente.documentos?.forEach(d => {
                        documentoId++;
                        d.id = documentoId;
                    });
                }
                result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                let resultCliente = result.cliente;
                //history.push("/nueva-solicitud");
                localStorage.setItem("idioma", result.idioma);
                if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                    localStorage.setItem("diasRad", result.diasRAD);
                }
                else{
                    localStorage.setItem("diasRad", "0");
                }

                const nuevaCotizacion = new Solicitud(initialSolicitud);
                const recoleccion = new Recoleccion(initialRecoleccionState);
                const nuevaMercancia = new Mercancia(initialMercancia);
                const copiaMercancias: Mercancia[] = [];
                copiaMercancias.push(nuevaMercancia);
                const copiaMercanciasComplementarias: MercanciaDatosComplementarios[] = [];

                props.setSolicitud(nuevaCotizacion);
                props.setSolicitudCopia(nuevaCotizacion);
                props.setRecoleccionOrigen(recoleccion);
                props.setRecoleccionDestino(recoleccion);
                props.saveMercancias(copiaMercancias);
                props.saveMercanciasDatosComplementarios(copiaMercanciasComplementarias);
                props.saveCliente(resultCliente);
                saveCliente(resultCliente);
                history.push("/nueva-solicitud");
            setLoading(false);
            }
        });        
    }

    const obtenerAreaServicio = async (areaServicioId) => {
        let result: AreaServicio = await apiSource.obtenerPorIdAsync("area-servicio", areaServicioId);

        return new AreaServicio(result);
    }

    const guardarInformacionRender = (response, solicitud, recoleccionOrigen, recoleccionDestino, resultCliente) => {
        props.setSolicitud(solicitud);
        props.setSolicitudCopia(solicitud);
        props.setRecoleccionOrigen(recoleccionOrigen);
        props.setRecoleccionDestino(recoleccionDestino);

        /* Mercancias */
        obtenerMercancias(response, props.saveMercancias, false);
        if(JSON.stringify(props.cliente) === JSON.stringify(resultCliente)){
            setLoading(false);
            history.push("/nueva-solicitud");
        }
        if(JSON.stringify(props.cliente) !== JSON.stringify(resultCliente)){
            setLoading(true);
            history.push("/nueva-solicitud");
            props.saveCliente(resultCliente);
            localStorage.setItem("clienteString", JSON.stringify(resultCliente));
            
        }
    }
    
    const guardarInformacion = (response, solicitud, recoleccionOrigen, recoleccionDestino) => {
        props.setSolicitud(solicitud);
        props.setSolicitudCopia(solicitud);
        props.setRecoleccionOrigen(recoleccionOrigen);
        props.setRecoleccionDestino(recoleccionDestino);

        /* Mercancias */
        obtenerMercancias(response, props.saveMercancias, false);
        setLoading(false);
        history.push("/nueva-solicitud");

    }

    const obtenerServiciosSeleccionados = (
        catalogo: IServicioAdicional[] | undefined,
        conceptos: any[] | undefined,
        esOrigen: boolean
    ): ServicioAdicional[] => {
        const conceptosPorId = new Map<number, any>();

        (conceptos ?? []).forEach(concepto => {
            const conceptoId =
                concepto.conceptoID ?? concepto.concepto?.conceptoID;
            const aplicaAlLado = esOrigen
                ? concepto.aplicaOrigen === true
                : concepto.aplicaDestino === true ||
                    concepto.aplicaOrigen === false;

            if (
                conceptoId !== undefined &&
                aplicaAlLado &&
                !conceptosPorId.has(conceptoId)
            ) {
                conceptosPorId.set(conceptoId, concepto);
            }
        });

        const idsAgregados = new Set<number>();

        return (catalogo ?? []).reduce(
            (resultado: ServicioAdicional[], servicio) => {
                if (
                    idsAgregados.has(servicio.id) ||
                    !conceptosPorId.has(servicio.id)
                ) {
                    return resultado;
                }

                idsAgregados.add(servicio.id);
                const nuevoServicio = new ServicioAdicional(servicio);
                nuevoServicio.seleccionado = true;
                nuevoServicio.aplicaOrigen = esOrigen;
                nuevoServicio.aplicaDestino = !esOrigen;
                resultado.push(nuevoServicio);

                return resultado;
            },
            []
        );
    };

    const nuevaSolicitud = async (solicitudId) => {
        setLoading(true);

        if (await limiteServicioDiarioAlcanzado()) {
            return;
        }

        let resultCliente:any;
        actualizaLoginData(Number(props.cliente.id), Number(props.usuario.id), localStorage.getItem("usuario_nombre")).then(result => {

            let documentoId = 0;
            if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                result.cliente.habilitarDatosComplementarios = false;
                if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                    result.cliente.habilitarDatosComplementarios = true;
                }
                if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                    result.cliente.habilitarDatosComplementariosCartaPorte = true;
                }
                if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                    result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                }
                if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                    result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                }
                if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                    result.cliente.habilitarValidacionCoberturaEAD = true;
                }
                if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                    result.cliente.habilitarValidacionCoberturaRAD = true;
                }
                //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                //result.cliente.clienteConfiguracionMarkupDetalle = 0;

                if (result.cliente?.documentos !== null) {
                    result.cliente.documentos?.forEach(d => {
                        documentoId++;
                        d.id = documentoId;
                    });
                }
                result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                localStorage.setItem("idioma", result.idioma);
                resultCliente = result.cliente;
                //props.saveCliente(resultCliente);
                
                if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                    localStorage.setItem("diasRad", result.diasRAD);
                }
                else{
                    localStorage.setItem("diasRad", "0");
                }
            }
        }).then(result => {
            getFullSolicitud(solicitudId).then(async response => {
                /* Solicitud*/
                const nuevaSolicitudServicio = new Solicitud(initialSolicitud);
                nuevaSolicitudServicio.SetValores(response, false, true)
    
                nuevaSolicitudServicio.seccionId = 1;
                nuevaSolicitudServicio.estatusId = 1;
                nuevaSolicitudServicio.completada = false;
                nuevaSolicitudServicio.modificar = true;
                nuevaSolicitudServicio.serviciosAdicionales = response.solicitudConceptos;
                nuevaSolicitudServicio.esSolicitarDeNuevo = false;
                
                if (response.distribuidorRemitente !== null) {
                    nuevaSolicitudServicio.distribuidorRemitente = await obtenerCoordenadas(response.distribuidorRemitente);
                    nuevaSolicitudServicio.distribuidorRemitente.direccion = nuevaSolicitudServicio.direccionRemitente;
                }
    
                if (response.distribuidorDestinatario !== null) {
                    nuevaSolicitudServicio.distribuidorDestinatario = await obtenerCoordenadas(response.distribuidorDestinatario);
                    nuevaSolicitudServicio.distribuidorDestinatario.direccion = nuevaSolicitudServicio.direccionDestinatario;
                }
                obtenerMercancias(response, props.saveMercancias, false);
                /* Origen*/
                const recoleccionOrigen = new Recoleccion(initialRecoleccionState);
    
                const fechaRAD = (response.fechaCitaRAD === null) ? new Date('1900-01-01T00:00:00') : new Date(response.fechaCitaRAD);
		        const fechaRADCedis = (response.solicitudServicioRadEadCedis === null) ? new Date('1900-01-01T00:00:00') : new Date(response.solicitudServicioRadEadCedis.fechaCitaRADCedis);
                const fechaDefault = new Date('1900-01-01T00:00:00');
                if (fechaDefault.getFullYear() !== fechaRAD.getFullYear()){
	                //recoleccionOrigen.fechaCita = fechaRAD;
	                nuevaSolicitudServicio.tipoDeRecoleccionOrigen = 2;
	            }
	            if (fechaDefault.getFullYear() !== fechaRADCedis.getFullYear() && fechaDefault.getFullYear() === fechaRAD.getFullYear()){
	                //recoleccionOrigen.fechaCita = fechaRADCedis;
	                recoleccionOrigen.EsCitaRadCedis = true;
	                nuevaSolicitudServicio.tipoDeRecoleccionOrigen = 4;
	            }
	            if (fechaDefault.getFullYear() === fechaRADCedis.getFullYear() && fechaDefault.getFullYear() === fechaRAD.getFullYear())
	                recoleccionOrigen.fechaCita = undefined;
    
    
                if (response.esRadCitaFueraHorario === true) {
                    recoleccionOrigen.EsFueraHorario = response.esRadCitaFueraHorario;
                    //recoleccionOrigen.horaFHDe = nuevaSolicitudServicio.RadCitaHoraDe;
                    //recoleccionOrigen.horaFHHasta = nuevaSolicitudServicio.RadCitaHoraHasta;
			        nuevaSolicitudServicio.tipoDeRecoleccionOrigen = 3;	
                }
    
                recoleccionOrigen.SetValores(response, true, false);
                recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.comercial;
                if (response.esResidencialOrigen === true) {
                    recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.residencial;
                }
                if (response.esOcurreOrigen === true || response.esOcurreOrigen === 1) {
                    recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.ocurre;
                }
                recoleccionOrigen.distribuidor = nuevaSolicitudServicio.distribuidorRemitente;
                recoleccionOrigen.areaServicio = await obtenerAreaServicio(response.areaServicioRemitente.id);
                const nuevosServiciosOrigen = obtenerServiciosSeleccionados(
                    recoleccionOrigen.areaServicio.serviciosAdicionales,
                    response.solicitudConceptos,
                    true
                );

            nuevaSolicitudServicio.serviciosAdicionalesOrigen = nuevosServiciosOrigen;
            completarValoresRecoleccion(recoleccionOrigen, recoleccionOrigen.areaServicio, props.cliente, true);

            /* Destino*/
            const recoleccionDestino = new Recoleccion(initialRecoleccionState);
            recoleccionDestino.SetValores(response, false, false);
            recoleccionDestino.distribuidor = nuevaSolicitudServicio.distribuidorDestinatario;
            recoleccionDestino.areaServicio = await obtenerAreaServicio(response.areaServicioDestinatario.id);
            const nuevosServiciosDestino = obtenerServiciosSeleccionados(
                    recoleccionDestino.areaServicio.serviciosAdicionales,
                    response.solicitudConceptos,
                    false
            );
            nuevaSolicitudServicio.serviciosAdicionalesDestino = nuevosServiciosDestino;


            const fechaCitaEAD = (response.fechaCitaEAD === null) ? new Date('1900-01-01T00:00:00') : new Date(response.fechaCitaEAD);
            const fechaCitaEADCedis = (response.solicitudServicioRadEadCedis === null) ? new Date('1900-01-01T00:00:00') : new Date(response.solicitudServicioRadEadCedis.fechaCitaEADCedis);
            const fechaDefaultEAD = new Date('1900-01-01T00:00:00');
            nuevaSolicitudServicio.tipoDeRecoleccionDestino = 1;
            if (fechaDefaultEAD.getFullYear() !== fechaCitaEAD.getFullYear()){
                //recoleccionDestino.fechaCita = fechaCitaEAD;
                nuevaSolicitudServicio.tipoDeRecoleccionDestino = 2;
            }
            if (fechaDefaultEAD.getFullYear() !== fechaCitaEADCedis.getFullYear() && fechaDefaultEAD.getFullYear() === fechaCitaEAD.getFullYear()){
                //recoleccionDestino.fechaCita = fechaCitaEADCedis;
                recoleccionDestino.EsCitaEadCedis = true;
                nuevaSolicitudServicio.tipoDeRecoleccionDestino = 4;
            }
            if (fechaDefaultEAD.getFullYear() === fechaCitaEADCedis.getFullYear() && fechaDefaultEAD.getFullYear() === fechaCitaEAD.getFullYear())
                recoleccionDestino.fechaCita = undefined;

            recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.comercial;
            if (response.esResidencialDestino === true) {
                recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.residencial;
            }
            if (response.esOcurreDestino === true || response.esOcurreDestino === 1) {
                recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.ocurre;
            }
            if (response.esEadCitaFueraHorario === true) {
                recoleccionDestino.EsFueraHorario = response.esEadCitaFueraHorario;
                //recoleccionDestino.horaFHDe = nuevaSolicitudServicio.EadCitaHoraDe;
                //recoleccionDestino.horaFHHasta = nuevaSolicitudServicio.EadCitaHoraHasta;
                nuevaSolicitudServicio.tipoDeRecoleccionDestino = 3;
            }

            completarValoresRecoleccion(recoleccionDestino, recoleccionDestino.areaServicio, props.cliente, false);
            if(nuevaSolicitudServicio.tipoServicio && nuevaSolicitudServicio.tipoServicio.id !== 3){
                nuevaSolicitudServicio.tipoServicio = await getTipoServicio(recoleccionOrigen, recoleccionDestino);
            }
            await saveServicioAdicionales(recoleccionOrigen, recoleccionDestino, nuevaSolicitudServicio, true);

            /*Cliente*/
            setUsuario({ ...props.usuario, email: response.correo });
            let params ={
                 paisId: recoleccionOrigen.distribuidor?.colonia?.paisID,
                 estadoId: recoleccionOrigen.distribuidor?.colonia?.estado?.id,
                 ciudadId: recoleccionOrigen.distribuidor?.ciudadId,
                 codigoPostal: recoleccionOrigen.distribuidor?.codigoPostal,
                 empresaId: response?.empresaID,
                 ClienteID: recoleccionOrigen.distribuidor?.clienteID,
                 ClienteDistribuidorID: recoleccionOrigen.distribuidor?.clienteDistribuidorID
            };
            let result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", params);

            if( result != null &&
                result.recintoAduanal != null &&
                result.recintoAduanal.length > 0)
            {
                Object.assign(recoleccionOrigen, {
                    recintoAduanal: result?.recintoAduanal
                });
            }
            guardarInformacion(response, nuevaSolicitudServicio, recoleccionOrigen, recoleccionDestino);
        });

    });    
    }   

    const getFullSolicitud = async (solicitudID) => {
        const result = await apiSource.obtenerAsync<any>("/solicitud-servicio/full-solicitud/" + Number(solicitudID));
        return result;
    }

    const verSolicitud = (solicitudID) => {
        setLoading(true);
        getFullSolicitud(solicitudID).then(async response => {
            if (response !== '') {
                /* Solicitud*/
                const nuevaSolicitudServicio = new Solicitud(initialSolicitud);
                nuevaSolicitudServicio.SetValores(response, false, true);

                nuevaSolicitudServicio.proyecto = {
                    id: response.proyecto?.clienteCreditoProyectoID,
                    descripcion: response.proyecto?.descripcion
                }

                nuevaSolicitudServicio.seccionId = 8;
                nuevaSolicitudServicio.estatusId = 8;
                nuevaSolicitudServicio.completada = true;
                nuevaSolicitudServicio.modificar = false;
                nuevaSolicitudServicio.solicitudId = response.solicitudServicioID;
                nuevaSolicitudServicio.id = response.solicitudServicioID;
                nuevaSolicitudServicio.retencion = response.retencion;
                nuevaSolicitudServicio.archivosAdjuntos = response.solicitudArchivos;
                nuevaSolicitudServicio.esDetalle = true;
                if (response.distribuidorRemitente !== null) {
                    nuevaSolicitudServicio.distribuidorRemitente = await obtenerCoordenadas(response.distribuidorRemitente);
                }

                if (response.distribuidorDestinatario !== null) {
                    nuevaSolicitudServicio.distribuidorDestinatario = await obtenerCoordenadas(response.distribuidorDestinatario);
                }

                /* Origen*/
                const recoleccionOrigen = new Recoleccion(initialRecoleccionState);
                recoleccionOrigen.SetValores(response, true, false);

                /* Destino*/
                const recoleccionDestino = new Recoleccion(initialRecoleccionState);
                recoleccionDestino.SetValores(response, false, false);

                const serviciosAdicionales: any = [];
                response.solicitudConceptos?.forEach(e => {
                    const nombreConcepto = e.concepto?.nombreConcepto ?? "";

                    if (nombreConcepto !== "" && nombreConcepto.toLowerCase() !== "a.p.c.") {
                        serviciosAdicionales.push({ nombre: nombreConcepto, etiquetaServicioAdicionalDto: {nombre: e.concepto?.etiquetaConcepto?.nombreConcepto} });
                    }
                })

                nuevaSolicitudServicio.serviciosAdicionales = serviciosAdicionales;

                guardarInformacion(response, nuevaSolicitudServicio, recoleccionOrigen, recoleccionDestino);
            }
            else {
                setLoading(false);
            }
        });
    }

    const currencyFormat = (num) => {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    const actualizaLoginData = async (clienteId, usuarioId, userName) => {
        const result = await apiSource.obtenerAsync<IDatosLogin>("login/login-data", { clienteId: clienteId, usuarioId: usuarioId });
        return result;
    };

    return (<>
        <Container maxWidth="xl" className={classes.principal} >
            <Grid container spacing={3} >
                <Grid item xs={9} >
                    <Typography className={classes.sectionTitle}>
                        {/* Mis Solicitudes de Servicio */
                            traducirLabel(185)}
                    </Typography>
                </Grid>
                <Grid item xs={3} style={{ textAlign: "right" }}>
                    <Button variant="contained" color="primary" onClick={handleClick}>
                        {/* Nueva Solicitud de Servicio */
                            traducirLabel(212)}
                    </Button>
                </Grid>

            </Grid>
        </Container>

        {!ocultarPortal && <Container maxWidth="xl" className={classes.filters} >
            <Grid container spacing={2}>
                <Grid item xs={1} className={classes.label}>
                    {/* Solicitud Servicio */
                        traducirLabel(282)}
                </Grid>
                <Grid item xs={2}>
                    <TextField id="outlined-basic" variant="outlined" className={classes.textField}
                        value={solicitudId} size="small"
                        InputProps={{
                            inputComponent: ReferenciaNumberField as any,
                            inputProps: { precision: 0, maxLength: 11, min: 0 },
                        }}
                        onChange={e => setSolicitudId(e.target.value)} />

                </Grid>
                <Grid item xs={1} className={classes.label}>
                    {/* Fecha Inicio */
                        traducirLabel(134)}
                </Grid>

                <Grid item xs={2}>
                    
                    {localStorage.getItem("idioma") === 'en-US' &&
                        <CustomProvider locale={en_US}>
                            <DatePicker oneTap
                                format="MM-dd-yyyy" 
                                className="almex-datepicker"
                                value={fechaInicio}
                                onChange={setFechaInicio}
                                disabledDate={(current:any) => {
                                    return moment(fechaFin,'MM-dd-yyyy')  < current;
                                    }}
                            />
                        </CustomProvider>
                    }
                    {localStorage.getItem("idioma") !== 'en-US' &&
                        <CustomProvider locale={es_ES}>
                            <DatePicker oneTap
                                format="dd-MM-yyyy" 
                                className="almex-datepicker"
                                value={fechaInicio}
                                onChange={setFechaInicio}
                                disabledDate={(current:any) => {
                                    return moment(fechaFin,'dd-MM-yyyy')  < current;
                                    }}
                            />
                        </CustomProvider>
                    }
                </Grid>
                <Grid item xs={1} className={classes.label}>
                    {/* Fecha Fin */
                        traducirLabel(133)}
                </Grid>
                <Grid item xs={2}>
                    {localStorage.getItem("idioma") === 'en-US' &&
                        <CustomProvider locale={en_US}>
                            <DatePicker oneTap
                                format="MM-dd-yyyy" 
                                className="almex-datepicker"
                                value={fechaFin}
                                onChange={setFechaFin}
                                disabledDate={(current:any) => {
                                    return moment().add(0, 'days')  < current;
                                    }}
                            />

                        </CustomProvider>
                    }
                    {localStorage.getItem("idioma") !== 'en-US' &&
                        <CustomProvider locale={es_ES}>
                        
                            <DatePicker oneTap
                                format="dd-MM-yyyy" 
                                className="almex-datepicker"
                                value={fechaFin}
                                onChange={setFechaFin}
                                disabledDate={(current:any) => {
                                    return moment()  < current;
                                    }}
                            />
                        </CustomProvider>
                    
                    }
                </Grid>
                <Grid item xs={1}  >
                    <Button className={classes.icon} color="primary" variant="contained" onClick={() => buscarSolicitudes()}>
                        <Search />
                    </Button>
                </Grid>
            </Grid>

            <Grid container spacing={2}>

                <Grid item xs={1} className={classes.label}>
                    {/* Estatus */
                        traducirLabel(125)}
                </Grid>
                <Grid item xs={2}>
                    <FormControl size="small">
                        <Select variant="outlined" className={classes.selectFilter}
                            labelId="estatus-label"
                            id="estatus"
                            value={estatusId}
                            onChange={e => setEstatusId(Number(e.target.value))}
                        >
                            <MenuItem key={-1} value={-1}>
                                --{/* --Seleccione-- */
                                    traducirLabel(323)}--
                            </MenuItem>
                            {estatus !== null && estatus.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.nombre}
                                </MenuItem>
                            ))}

                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={1} className={classes.label}>
                    {/* Referencia */
                        traducirLabel(258)}
                </Grid>
                <Grid item xs={2}>
                    <TextField id="outlined-basic" variant="outlined" className={classes.textField}
                        value={referencia} size="small"
                        inputProps={{ maxLength: 25 }}
                        onChange={e => setReferencia(e.target.value)} />
                </Grid>
            </Grid>

            <Grid container spacing={2} >
                <Grid item xs={1} >
                    <div className={classes.label}>
                        {/* Origen */
                            traducirLabel(222)}
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <FormControl size="small">
                        <Autocomplete
                            className={classes.selectFilter}
                            options={areasServicios.areasServicios}
                            getOptionLabel={(option) => option.nombre}
                            onChange={(event, value) => setOrigen(value !== null ? value.id : 0)}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        />

                    </FormControl>
                </Grid>
                <Grid item xs={1} >
                    <div className={classes.label}>
                        {/* Destino */
                            traducirLabel(86)}
                    </div>
                </Grid>

                <Grid item xs={2}>
                    <FormControl size="small">
                        <Autocomplete
                            className={classes.selectFilter}
                            options={areasServicios.areasServicios}
                            getOptionLabel={(option) => option.nombre}
                            onChange={(event, value) => setDestino(value !== null ? value.id : 0)}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={1} >
                    <div className={classes.label}>
                        {/* Oficina Origen */
                            traducirLabel(220)}
                    </div>
                </Grid>

                <Grid item xs={2}>
                    <FormControl size="small">
                        <Autocomplete
                            className={classes.selectFilter}
                            options={props.sucursalesMany}
                            getOptionLabel={(option) => option.nombre}
                            onChange={(event, value) => setOficinaOrigen(value !== null ? value.id : 0)}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={1} >
                    <div className={classes.label}>
                        {/* Oficina Destino */
                            traducirLabel(219)}
                    </div>
                </Grid>

                <Grid item xs={2}>
                    <FormControl size="small">
                        <Autocomplete
                            className={classes.selectFilter}
                            options={props.sucursalesMany}
                            getOptionLabel={(option) => option.nombre}
                            onChange={(event, value) => setOficinaDestino(value !== null ? value.id : 0)}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </Container>}

         {!ocultarPortal && <Container maxWidth="xl" style={{ padding: "0" }}>
            <Grid container>
                <Grid item xs={12} className={classes.label}>
                    <Help comments={traducirMessage(134)} customStyle={{ top: "0", right: "0px" }} />
                </Grid>
            </Grid>
         </Container>}

        {!ocultarPortal && <Container maxWidth="xl" className={classes.table}>
            <TableContainer >
                <Table aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tr}>
                                {/* NO. SOLICITUD */
                                    traducirLabel(199)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* FECHA */
                                    traducirLabel(129)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* ENVÍO */
                                    traducirLabel(122)}
                            </TableCell>
                            <TableCell className={classes.trLeft}>
                                {/* MERCANCÍA */
                                    traducirLabel(178)}
                            </TableCell>
                            <TableCell className={classes.trLeft}>
                                {/* TOTAL */
                                    traducirLabel(305)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* ESTATUS */
                                    traducirLabel(125)}
                            </TableCell>
                            <TableCell className={classes.tr} />
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {(rowsPerPage > 0
                            ? solicitudes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : solicitudes
                        ).map((row, i) => (
                            <TableRow key={i}>
                                <TableCell component="td" scope="row" className={classes.cellContent} style={{ color: "#00653b", fontSize: "14px", fontWeight: 700, textAlign: "center", cursor: "pointer" }}>
                                    <span onClick={() => verSolicitud(row.solicitudId)}>
                                        {row.id}
                                    </span>
                                </TableCell>
                                <TableCell component="td" scope="row" className={classes.cellContent}>
                                    {row.fecha}
                                </TableCell>
                                <TableCell component="td" scope="row" style={{ textAlign: "center" }}>
                                    <TableRow  >
                                        <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "12px", fontWeight: "bolder", minWidth: "200px" }}>
                                            {row.ocurreOrigen === 1 ? traducirLabel(256) : row.sucursalRemitente !== null ? row.sucursalRemitente.nombre : '' /*'Recolección en Sucursal'*/}
                                        </TableCell>
                                        <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px" }}>
                                        </TableCell>
                                        <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "12px", fontWeight: "bolder", minWidth: "150px" }}>
                                            {row.ocurreDestino === 1 ? traducirLabel(116) : row.sucursalDestinatario !== null ? row.sucursalDestinatario.nombre : ''/*'Entrega en Sucursal'*/}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "300px", padding: "8px" }}>
                                            {row.direccionRemitente}
                                        </TableCell>
                                        <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px" }}>
                                            <ArrowRightAlt style={{ verticalAlign: "middle" }} />
                                        </TableCell>
                                        <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "300px", padding: "8px" }}>
                                            {row.direccionDestinatario}
                                        </TableCell>
                                    </TableRow>
                                </TableCell>
                                <TableCell component="td" scope="row" style={{ minWidth: "200px" }}>
                                    {(row.mercancia).map((mercancia, m) => (
                                        <TableRow key={m} >
                                            <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "20px", padding: "2px" }}>
                                                {mercancia.cantidad}
                                            </TableCell>
                                            {localStorage.getItem("idioma") === 'en-US' &&
                                                <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "200px", padding: "2px" }}>
                                                    {mercancia.embalaje?.etiquetaEmbalaje?.nombre}
                                                </TableCell>
                                            }
                                            {localStorage.getItem("idioma") !== 'en-US' &&
                                                <TableCell component="div" variant="head" style={{ borderBottom: 0, lineHeight: "1rem", fontSize: "11px", width: "200px", padding: "2px" }}>
                                                    {mercancia.embalaje?.nombre}
                                                </TableCell>
                                            }
                                        </TableRow>
                                    ))}
                                </TableCell>
                                <TableCell component="td" scope="row" style={{ fontWeight: 700, textAlign: "center", fontSize: "12px", minWidth: "150px" }}>
                                    {currencyFormat(row.total)} {row.moneda}

                                </TableCell>
                                <TableCell component="td" scope="row" style={{ color: "red", fontSize: "12px", textAlign: "center" }}>
                                    {parseInt(row.estatusId) === estatus[parseInt(row.estatusId)-1].id ? estatus[parseInt(row.estatusId)-1].nombre : row.estatus}
                                </TableCell>
                                <TableCell component="td" scope="row" className={classes.cellContent}>
                                    <Button variant="contained" color="primary" size="small" className={classes.buttonCell} onClick={e => nuevaSolicitud(row.solicitudId)}>
                                        {/* Solicitar de nuevo */
                                            traducirButton(3)}
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={solicitudes.length}
                rowsPerPage={rowsPerPage}
                page={page}
                labelRowsPerPage=''
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Container>}

        {showLoading &&
            /*Procesando */
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>
    )
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    sucursales: state.sucursales,
    sucursalesMany: state.sucursalesMany,
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    saveMercancias: saveMercancias,
    saveMercanciasDatosComplementarios: saveMercanciasDatosComplementarios,
    setUsuario: setUsuario,
    updateServicios: updateServicios,
    saveTiposEnvio: saveTiposEnvio,
    saveCliente: saveCliente,
};

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudLista);
